import moment from 'moment';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Box from '../../../../components/Box';
import ColumnChooser from '../../../../components/ColumnChooser';
import CustomMultiSelect from '../../../../components/CustomMultiSelect';
import CustomSingleSelect, { CustomSingleSelectModel } from '../../../../components/CustomSingleSelect';
import ExcelExportMenu from '../../../../components/ExcelExportMenu';
import { ExcelExportMode } from '../../../../helpers/excelExportRequest';
import Filters from '../../../../components/Filters';
import { ColumnChooserModel } from '../../../../models/common/ColumnChooserModel';
import { GetUserListPagingAndFilterRequest } from '../../../../models/request/user/GetUserListPagingAndFilterRequest';
import { GetCompanyListResponseItem } from '../../../../models/response/company/GetCompanyListResponse';
import { RootState } from '../../../../redux/store';
import { CompanyService } from '../../../../services/CompanyService';
import { ConstantService } from '../../../../services/ConstantService';
import { MenuComponent } from '../../../../_metronic/assets/ts/components';
import TableConstantActions from '../../../../components/TableConstantActions';

interface Props {
    columns: ColumnChooserModel[]
    setColumns: React.Dispatch<React.SetStateAction<ColumnChooserModel[]>>
    getColumns: () => ColumnChooserModel[]
    pageName: string
    pageVersion: string
    excelExport: (mode: ExcelExportMode) => void
    filter: GetUserListPagingAndFilterRequest
    getData: (_filter?: GetUserListPagingAndFilterRequest | undefined) => Promise<void>
    setFilter: React.Dispatch<React.SetStateAction<GetUserListPagingAndFilterRequest>>
    selectedCount: number
    deleteFunction: () => void
    updateFunction: () => void
    onSearchSubmit: (e: any) => void
}

const UserListFilters = ({
    columns,
    setColumns,
    getColumns,
    pageName,
    pageVersion,
    excelExport,
    filter,
    getData,
    setFilter,
    selectedCount,
    deleteFunction,
    onSearchSubmit,
    updateFunction
}: Props) => {
    const navigate = useNavigate();
    const auth = useSelector((state: RootState) => state.auth)

    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)
    }, [])

    return (
        <React.Fragment>
            <TableConstantActions
                deleteFunction={deleteFunction}
                onSearchSubmit={onSearchSubmit}
                pageName={pageName}
                hideSearch={true}
                searchTerm={filter.searchTerm}
                selectedCount={selectedCount}
                setSearchTerm={(e) => setFilter({ ...filter, searchTerm: e })}
                updateFunction={updateFunction}
            />

            <ColumnChooser
                columns={columns}
                getColumns={getColumns}
                pageName={pageName}
                pageVersion={pageVersion}
                setColumns={setColumns}
            />

            <ExcelExportMenu
                pageName={pageName}
                selectedCount={selectedCount}
                onExport={excelExport}
            />

            {/* <Filters
                filter={filter}
                getData={getData}
                onReset={() => getData({
                    ...filter,
                    currentPage: 1,
                    skip: 0,
                    userDateStart: moment(new Date()).subtract(1, 'month').format("YYYY-MM-DD"),
                    userDateEnd: moment(new Date()).format("YYYY-MM-DD"),
                    selectedCustomer: undefined,
                    selectedUserTypes: [],
                    selectedUserCompanyTypes: defaultUserCompanyType ? [defaultUserCompanyType] : []
                })}
            >
                <div className='mb-5'>
                    <label className='form-label fw-bold'>Görüşme Tarihi:</label>

                    <Box gap='15px' flexDirection='row'>
                        <Box flex={1} justifyContent='center'>
                            <input
                                className="form-control form-control-solid"
                                type={'date'}
                                value={filter.userDateStart}
                                onChange={(e) => setFilter({
                                    ...filter,
                                    userDateStart: e.target.value
                                })}
                            />
                        </Box>
                        <Box flex={1} justifyContent='center'>
                            <input
                                className="form-control form-control-solid"
                                type={'date'}
                                value={filter.userDateEnd}
                                onChange={(e) => setFilter({
                                    ...filter,
                                    userDateEnd: e.target.value
                                })}
                            />
                        </Box>
                    </Box>
                </div>

                <div className='mb-5'>
                    <label className='form-label fw-bold'>Müşteri:</label>

                    <div>
                        <CustomSingleSelect
                            onChange={(e) => setFilter({
                                ...filter,
                                selectedCustomer: e
                            })}
                            selectedValue={filter.selectedCustomer}
                            onMenuOpen={() => CompanyService.getCompanyList({ isCustomer: true })}
                            labelName='name'
                            valueName='companyId'
                        />
                    </div>
                </div>

                <div className='mb-5'>
                    <label className='form-label fw-bold'>Görüşme Şekli:</label>

                    <div>
                        <CustomMultiSelect
                            onChange={(e) => setFilter({
                                ...filter,
                                selectedUserTypes: e
                            })}
                            selectedValues={filter.selectedUserTypes}
                            onMenuOpen={() => ConstantService.getConstantList('MEETING_TYPE')}
                            labelName='value'
                            valueName='constantId'
                            additionalValue1Name="additionalValue1"
                        />
                    </div>
                </div>

                <div className='mb-5'>
                    <label className='form-label fw-bold'>Firma Durumu:</label>

                    <div>
                        <CustomMultiSelect
                            onChange={(e) => setFilter({
                                ...filter,
                                selectedUserCompanyTypes: e
                            })}
                            selectedValues={filter.selectedUserCompanyTypes}
                            onMenuOpen={() => ConstantService.getConstantList('MEETING_COMPANY_TYPE')}
                            labelName='value'
                            valueName='constantId'
                            additionalValue1Name="additionalValue1"
                        />
                    </div>
                </div>
            </Filters> */}

            <React.Fragment>
                {
                    auth.user.user?.data.authorizedMenus.find(x => x.menuName == pageName)?.canInsert && (
                        <div className='m-0'>
                            <a
                                onClick={() => navigate('/user/listadd')}
                                className='btn btn-sm fw-bold btn-primary'
                            >
                                Yeni Kullanıcı Ekle
                            </a>
                        </div>
                    )
                }
            </React.Fragment>
        </React.Fragment>
    )
}

export default UserListFilters;